@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.premium.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.premium.resources/"

@delegate:ResourceContentHash(-1_588_317_831)
internal val Res.string.premium_benefit_alerts_text: StringResource by lazy {
      StringResource("string:premium_benefit_alerts_text", "premium_benefit_alerts_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 127),
      ))
    }

@delegate:ResourceContentHash(-517_260_506)
internal val Res.string.premium_benefit_alerts_title: StringResource by lazy {
      StringResource("string:premium_benefit_alerts_title", "premium_benefit_alerts_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138, 64),
      ))
    }

@delegate:ResourceContentHash(188_857_956)
internal val Res.string.premium_benefit_no_ads_text: StringResource by lazy {
      StringResource("string:premium_benefit_no_ads_text", "premium_benefit_no_ads_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203, 91),
      ))
    }

@delegate:ResourceContentHash(886_475_989)
internal val Res.string.premium_benefit_no_ads_title: StringResource by lazy {
      StringResource("string:premium_benefit_no_ads_title", "premium_benefit_no_ads_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295, 56),
      ))
    }

@delegate:ResourceContentHash(331_148_582)
internal val Res.string.premium_benefit_offline_text: StringResource by lazy {
      StringResource("string:premium_benefit_offline_text", "premium_benefit_offline_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352, 104),
      ))
    }

@delegate:ResourceContentHash(-1_124_846_685)
internal val Res.string.premium_benefit_offline_title: StringResource by lazy {
      StringResource("string:premium_benefit_offline_title", "premium_benefit_offline_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 457, 73),
      ))
    }

@delegate:ResourceContentHash(-2_099_526_184)
internal val Res.string.premium_benefit_soon: StringResource by lazy {
      StringResource("string:premium_benefit_soon", "premium_benefit_soon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 531, 40),
      ))
    }

@delegate:ResourceContentHash(-346_919_530)
internal val Res.string.premium_benefits_title: StringResource by lazy {
      StringResource("string:premium_benefits_title", "premium_benefits_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 572, 58),
      ))
    }

@delegate:ResourceContentHash(1_627_735_323)
internal val Res.string.premium_donation_notice: StringResource by lazy {
      StringResource("string:premium_donation_notice", "premium_donation_notice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 631, 115),
      ))
    }

@delegate:ResourceContentHash(-1_249_166_008)
internal val Res.string.premium_free_notice: StringResource by lazy {
      StringResource("string:premium_free_notice", "premium_free_notice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 747, 91),
      ))
    }

@delegate:ResourceContentHash(1_912_585_579)
internal val Res.string.premium_intro: StringResource by lazy {
      StringResource("string:premium_intro", "premium_intro", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 839, 105),
      ))
    }

@delegate:ResourceContentHash(-1_661_130_891)
internal val Res.string.premium_manage_subscription: StringResource by lazy {
      StringResource("string:premium_manage_subscription", "premium_manage_subscription", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 945, 63),
      ))
    }

@delegate:ResourceContentHash(1_464_248_136)
internal val Res.string.premium_refresh_error: StringResource by lazy {
      StringResource("string:premium_refresh_error", "premium_refresh_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1009, 101),
      ))
    }

@delegate:ResourceContentHash(1_420_507_852)
internal val Res.string.premium_retry: StringResource by lazy {
      StringResource("string:premium_retry", "premium_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1111, 37),
      ))
    }

@delegate:ResourceContentHash(-1_428_378_917)
internal val Res.string.premium_status_active: StringResource by lazy {
      StringResource("string:premium_status_active", "premium_status_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1149, 49),
      ))
    }

@delegate:ResourceContentHash(615_059_742)
internal val Res.string.premium_status_free: StringResource by lazy {
      StringResource("string:premium_status_free", "premium_status_free", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1199, 51),
      ))
    }

@delegate:ResourceContentHash(1_287_731_099)
internal val Res.string.premium_status_gifted: StringResource by lazy {
      StringResource("string:premium_status_gifted", "premium_status_gifted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1251, 57),
      ))
    }

@delegate:ResourceContentHash(117_106_455)
internal val Res.string.premium_status_loading: StringResource by lazy {
      StringResource("string:premium_status_loading", "premium_status_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1309, 66),
      ))
    }

@delegate:ResourceContentHash(1_373_071_743)
internal val Res.string.premium_status_no_end: StringResource by lazy {
      StringResource("string:premium_status_no_end", "premium_status_no_end", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1376, 49),
      ))
    }

@delegate:ResourceContentHash(746_470_888)
internal val Res.string.premium_status_unknown: StringResource by lazy {
      StringResource("string:premium_status_unknown", "premium_status_unknown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1426, 78),
      ))
    }

@delegate:ResourceContentHash(-1_258_119_596)
internal val Res.string.premium_status_until: StringResource by lazy {
      StringResource("string:premium_status_until", "premium_status_until", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1505, 48),
      ))
    }

@delegate:ResourceContentHash(-725_013_345)
internal val Res.string.premium_subscribe: StringResource by lazy {
      StringResource("string:premium_subscribe", "premium_subscribe", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1554, 61),
      ))
    }

@delegate:ResourceContentHash(-2_110_396_885)
internal val Res.string.premium_title: StringResource by lazy {
      StringResource("string:premium_title", "premium_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1616, 29),
      ))
    }

@delegate:ResourceContentHash(2_114_448_460)
internal val Res.string.premium_unavailable: StringResource by lazy {
      StringResource("string:premium_unavailable", "premium_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1646, 83),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("premium_benefit_alerts_text", Res.string.premium_benefit_alerts_text)
  map.put("premium_benefit_alerts_title", Res.string.premium_benefit_alerts_title)
  map.put("premium_benefit_no_ads_text", Res.string.premium_benefit_no_ads_text)
  map.put("premium_benefit_no_ads_title", Res.string.premium_benefit_no_ads_title)
  map.put("premium_benefit_offline_text", Res.string.premium_benefit_offline_text)
  map.put("premium_benefit_offline_title", Res.string.premium_benefit_offline_title)
  map.put("premium_benefit_soon", Res.string.premium_benefit_soon)
  map.put("premium_benefits_title", Res.string.premium_benefits_title)
  map.put("premium_donation_notice", Res.string.premium_donation_notice)
  map.put("premium_free_notice", Res.string.premium_free_notice)
  map.put("premium_intro", Res.string.premium_intro)
  map.put("premium_manage_subscription", Res.string.premium_manage_subscription)
  map.put("premium_refresh_error", Res.string.premium_refresh_error)
  map.put("premium_retry", Res.string.premium_retry)
  map.put("premium_status_active", Res.string.premium_status_active)
  map.put("premium_status_free", Res.string.premium_status_free)
  map.put("premium_status_gifted", Res.string.premium_status_gifted)
  map.put("premium_status_loading", Res.string.premium_status_loading)
  map.put("premium_status_no_end", Res.string.premium_status_no_end)
  map.put("premium_status_unknown", Res.string.premium_status_unknown)
  map.put("premium_status_until", Res.string.premium_status_until)
  map.put("premium_subscribe", Res.string.premium_subscribe)
  map.put("premium_title", Res.string.premium_title)
  map.put("premium_unavailable", Res.string.premium_unavailable)
}
